import React, { Fragment } from "react"
import styled, { css } from "styled-components"
import Tooltip from "rc-tooltip"

import { NON_BREAKING_HYPHEN } from "../unicodeChars"

const TooltipWrapper = (props) => {
  const visibleProp = props.visible != null ? {visible: props.visible} : {}

  return (
    <Tooltip
      overlay={<TooltipContent content={props.content} />}
      showArrow={false}
      mouseEnterDelay={props.mouseEnterDelay || 0.05}
      mouseLeaveDelay={props.mouseLeaveDelay || 0.05}
      placement={props.placement || 'top'}
      getTooltipContainer={() => document.getElementById(props.containerId)}
      {...visibleProp}
      // visible
    >
      {props.children}
    </Tooltip>
  )
}

export default TooltipWrapper

const charSubMap = {
  '+': <>&nbsp;</>,
  '-': NON_BREAKING_HYPHEN
}

const TooltipContent = ({content}) => (
  <span>
    {String(content).split('').map((char, i) => (
      <Fragment key={i}>
        {charSubMap[char] || char}
      </Fragment>
    ))}
  </span>
)

// need to drop this string into the styling of the container wherever this component is used
export const tooltipStyles = css`
  .rc-tooltip {
    opacity: 1;
  }
  .rc-tooltip-inner {
    background-color: #222222;
    color: #ddd;
    min-height: unset;
    text-transform: none;
    font-size: 2.2em;
    white-space: normal;
    max-width: 5.5em;
    width: min-content;
    text-align: center;
    line-height: 1.1em;
    padding: 0.1em 0.22em 0.22em 0.22em;
    border-radius: 0.225em;
    border: 2px solid #ddd;
    span {
      border: none;
    }
  }
`